import React, {Component} from 'react';
import {Redirect, Route, RouteProps} from 'react-router-dom';
import lodash from 'lodash';
import AccessDenied from "../AccessDenied";
import SecurityService from "../../Util/SecurityService";

interface Props extends RouteProps {
    permission?: string
    accountPermission?: string | string[]
}

class AuthenticateRoute extends Component <Props, {}> {
    render() {
        const renderComponent = (_props: any) => {
            if (!SecurityService.isLogged()) {
                if (!lodash.startsWith(window.location.pathname, '/login') || !lodash.startsWith(window.location.pathname, '/authentication')) {
                    return <Redirect to={`/login?redirectBackUrl=${window.location.href}`}/>
                }
                return <Redirect to={'/login'}/>
            }

            if (_props.permission && (!SecurityService.can(_props.permission))) {
                return (
                    <AccessDenied/>
                );
            }

            if (_props.accountPermission && !SecurityService.allowTo(_props.accountPermission)) {
                return (
                    <AccessDenied/>
                );
            }

            const OwnComponent = _props.component;

            return (
                <OwnComponent
                    {..._props}
                />
            );
        };

        return (
            <Route
                {...lodash.omit(this.props, 'component')}
                render={routeProps => {
                    return renderComponent({
                        ...this.props,
                        ...routeProps,
                        permission: this.props.permission
                    });
                }}
            />
        )
    }
}

export default AuthenticateRoute;
